/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './model';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bankingregistry": {
        "nested": {
          "plaid": {
            "nested": {
              "RetrieveApplicationRequest": {
                "fields": {
                  "plaidApplicationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveApplicationResponse": {
                "fields": {
                  "application": {
                    "type": ".squareup.bankingregistry.plaid.Application",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ListApplicationsRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListApplicationsResponse": {
                "fields": {
                  "applications": {
                    "type": ".squareup.bankingregistry.plaid.Application",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "UnlinkApplicationRequest": {
                "fields": {
                  "plaidApplicationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UnlinkApplicationResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "PlaidExchangeService": {
                "methods": {
                  "RetrieveApplication": {
                    "requestType": ".squareup.bankingregistry.plaid.RetrieveApplicationRequest",
                    "responseType": ".squareup.bankingregistry.plaid.RetrieveApplicationResponse"
                  },
                  "ListApplications": {
                    "requestType": ".squareup.bankingregistry.plaid.ListApplicationsRequest",
                    "responseType": ".squareup.bankingregistry.plaid.ListApplicationsResponse"
                  },
                  "UnlinkApplication": {
                    "requestType": ".squareup.bankingregistry.plaid.UnlinkApplicationRequest",
                    "responseType": ".squareup.bankingregistry.plaid.UnlinkApplicationResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bankingregistry?.nested?.plaid?.nested?.RetrieveApplicationRequest && !$root.nested?.squareup?.nested?.bankingregistry?.nested?.plaid?.nested?.RetrieveApplicationResponse && !$root.nested?.squareup?.nested?.bankingregistry?.nested?.plaid?.nested?.ListApplicationsRequest && !$root.nested?.squareup?.nested?.bankingregistry?.nested?.plaid?.nested?.ListApplicationsResponse && !$root.nested?.squareup?.nested?.bankingregistry?.nested?.plaid?.nested?.UnlinkApplicationRequest && !$root.nested?.squareup?.nested?.bankingregistry?.nested?.plaid?.nested?.UnlinkApplicationResponse && !$root.nested?.squareup?.nested?.bankingregistry?.nested?.plaid?.nested?.PlaidExchangeService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveApplicationRequest @ squareup/bankingregistry/plaid/service.proto at 38:1
 */
export const RetrieveApplicationRequest = $root.lookupType('squareup.bankingregistry.plaid.RetrieveApplicationRequest');
fixType(RetrieveApplicationRequest, {
  plaidApplicationId: {
    required: true
  }
});
Builder.createAndAttachToType(RetrieveApplicationRequest);
/**
 * SOURCE RetrieveApplicationResponse @ squareup/bankingregistry/plaid/service.proto at 45:1
 */
export const RetrieveApplicationResponse = $root.lookupType('squareup.bankingregistry.plaid.RetrieveApplicationResponse');
fixType(RetrieveApplicationResponse);
Builder.createAndAttachToType(RetrieveApplicationResponse);
/**
 * SOURCE ListApplicationsRequest @ squareup/bankingregistry/plaid/service.proto at 57:1
 */
export const ListApplicationsRequest = $root.lookupType('squareup.bankingregistry.plaid.ListApplicationsRequest');
fixType(ListApplicationsRequest, {
  merchantToken: {
    required: true
  }
});
Builder.createAndAttachToType(ListApplicationsRequest);
/**
 * SOURCE ListApplicationsResponse @ squareup/bankingregistry/plaid/service.proto at 64:1
 */
export const ListApplicationsResponse = $root.lookupType('squareup.bankingregistry.plaid.ListApplicationsResponse');
fixType(ListApplicationsResponse);
Builder.createAndAttachToType(ListApplicationsResponse);
/**
 * SOURCE UnlinkApplicationRequest @ squareup/bankingregistry/plaid/service.proto at 76:1
 */
export const UnlinkApplicationRequest = $root.lookupType('squareup.bankingregistry.plaid.UnlinkApplicationRequest');
fixType(UnlinkApplicationRequest, {
  plaidApplicationId: {
    required: true
  }
});
Builder.createAndAttachToType(UnlinkApplicationRequest);
/**
 * SOURCE UnlinkApplicationResponse @ squareup/bankingregistry/plaid/service.proto at 83:1
 */
export const UnlinkApplicationResponse = $root.lookupType('squareup.bankingregistry.plaid.UnlinkApplicationResponse');
fixType(UnlinkApplicationResponse);
Builder.createAndAttachToType(UnlinkApplicationResponse);
/**
 * --
 * @desc Internal RPCs for calling Plaid Exchange APIs on behalf of merchants. See: https://plaid.com/exchange/docs/
 * --
 *
 * SOURCE PlaidExchangeService @ squareup/bankingregistry/plaid/service.proto at 15:1
 */
export const PlaidExchangeService = $root.lookupService('squareup.bankingregistry.plaid.PlaidExchangeService');